import { render, staticRenderFns } from "./Adicionales.vue?vue&type=template&id=0e021fae"
import script from "./Adicionales.vue?vue&type=script&lang=js"
export * from "./Adicionales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports